/* 列傳模式（單機）
 * 開一章：換上那一章的地圖，建一個沒有城寨、小兵、野怪、呂布、東風、玉璽、糧車的世界，只留主角；
 * 離開列傳時 SG.CAMPAIGN.leave() 換回赤壁。原本的模式完全不經過這裡。
 * 探索迷霧：地圖切成 FQ 見方的格子，每隊記一份「看過沒」；同隊任何單位看到的格子全隊都算看過（隊友共用）。
 * 畫面上沒看過的地方是黑的，看過但現在看不到的是暗的（view.drawFog）。 */
// @ts-nocheck
import { SG } from '../core/sg.ts';
import { fieldMap } from './field.ts';
import xihua from './maps/xihua.ts';
import shenting from './maps/shenting.ts';
import wan from './maps/wan.ts';
import liangdong from './maps/liangdong.ts';
import yangren from './maps/yangren.ts';
import niuzhu from './maps/niuzhu.ts';
import xuancheng from './maps/xuancheng.ts';
import dantu from './maps/dantu.ts';
import mianku from './maps/mianku.ts';
import chaisang from './maps/chaisang.ts';
import chibi from './maps/chibi.ts';
import xiaoyao from './maps/xiaoyao.ts';
import ruxu from './maps/ruxu.ts';
import jiangling from './maps/jiangling.ts';
import yiling from './maps/yiling.ts';
import bianshui from './maps/bianshui.ts';
import zhongmou from './maps/zhongmou.ts';
import jibei from './maps/jibei.ts';
import yushui from './maps/yushui.ts';
import puyang from './maps/puyang.ts';
import xiapi from './maps/xiapi.ts';
import baima from './maps/baima.ts';
import wuchao from './maps/wuchao.ts';
import bailang from './maps/bailang.ts';
import tongguan from './maps/tongguan.ts';
import dingjun from './maps/dingjun.ts';
import anxi from './maps/anxi.ts';
import beihai from './maps/beihai.ts';
import longzhong from './maps/longzhong.ts';
import changban from './maps/changban.ts';
import luocheng from './maps/luocheng.ts';
import hanshui from './maps/hanshui.ts';
import { startMission } from './mission.ts';
import sunjian1 from './story/sunjian1.ts';
import sunwu2 from './story/sunwu2.ts';
import sunwu3 from './story/sunwu3.ts';
import sunwu4 from './story/sunwu4.ts';
import sunwu5 from './story/sunwu5.ts';
import sunwu6 from './story/sunwu6.ts';
import sunwu7 from './story/sunwu7.ts';
import sunwu8 from './story/sunwu8.ts';
import sunwu9 from './story/sunwu9.ts';
import sunwu10 from './story/sunwu10.ts';
import sunwu11 from './story/sunwu11.ts';
import sunwu12 from './story/sunwu12.ts';
import sunwu13 from './story/sunwu13.ts';
import sunwu14 from './story/sunwu14.ts';
import sunwu15 from './story/sunwu15.ts';
import sunwu16 from './story/sunwu16.ts';
import sunwu17 from './story/sunwu17.ts';
import sunwu18 from './story/sunwu18.ts';
import caocao1 from './story/caocao1.ts';
import caocao2 from './story/caocao2.ts';
import caocao3 from './story/caocao3.ts';
import caocao4 from './story/caocao4.ts';
import caocao5 from './story/caocao5.ts';
import caocao6 from './story/caocao6.ts';
import caocao7 from './story/caocao7.ts';
import caocao8 from './story/caocao8.ts';
import caocao9 from './story/caocao9.ts';
import caocao10 from './story/caocao10.ts';
import caocao11 from './story/caocao11.ts';
import caocao12 from './story/caocao12.ts';
import liubei1 from './story/liubei1.ts';
import liubei2 from './story/liubei2.ts';
import liubei3 from './story/liubei3.ts';
import liubei4 from './story/liubei4.ts';
import liubei5 from './story/liubei5.ts';
import liubei6 from './story/liubei6.ts';
import liubei7 from './story/liubei7.ts';
import liubei8 from './story/liubei8.ts';
import liubei9 from './story/liubei9.ts';
import liubei10 from './story/liubei10.ts';
import liubei11 from './story/liubei11.ts';
import './draw.ts';
import SOLO from './lists/index.ts';
import './context.ts';
import CAST from './cast.ts';
import PEOPLE from './people.ts';

const MAPS = { xihua, shenting, wan, liangdong, yangren, niuzhu, xuancheng, dantu, mianku, chaisang, chibi, xiaoyao, ruxu, jiangling, yiling, bianshui, zhongmou, jibei, yushui, puyang, xiapi, baima, wuchao, bailang, tongguan, dingjun, anxi, beihai, longzhong, changban, luocheng, hanshui };
const CHAPTERS = Object.fromEntries([sunjian1, sunwu2, sunwu3, sunwu4, sunwu5, sunwu6, sunwu7, sunwu8, sunwu9, sunwu10, sunwu11, sunwu12, sunwu13, sunwu14, sunwu15, sunwu16, sunwu17, sunwu18, caocao1, caocao2, caocao3, caocao4, caocao5, caocao6, caocao7, caocao8, caocao9, caocao10, caocao11, caocao12, liubei1, liubei2, liubei3, liubei4, liubei5, liubei6, liubei7, liubei8, liubei9, liubei10, liubei11].map((c) => [c.id, c]));
// 單獨列傳（src/campaign/lists/）：各自登錄的章節、地圖併進來
for (const L of SOLO) { Object.assign(MAPS, L.maps); for (const c of L.chapters) CHAPTERS[c.id] = c; }
const FQ = 100, FOG_EVERY = 0.2;

function makeFog(M) {
  const cols = Math.ceil(M.W / FQ), rows = Math.ceil(M.H / FQ);
  return { q: FQ, cols, rows, seen: [new Uint8Array(cols * rows), new Uint8Array(cols * rows)], ver: [0, 0], t: 0 };
}
// 把每隊所有活著的單位視野內的格子記成看過（視野是地面上的橢圓，跟 sim 的 gd 一樣）
function reveal(w) {
  const F = w.campaign.fog, K = SG.K;
  for (const u of w.units) {
    if (!u.alive || !(u.team === 0 || u.team === 1)) continue;
    const s = SG.sightOf(u) + FQ * 0.5, S = F.seen[u.team];
    const i0 = Math.max(0, Math.floor((u.x - s) / FQ)), i1 = Math.min(F.cols - 1, Math.floor((u.x + s) / FQ));
    const j0 = Math.max(0, Math.floor((u.y - s * K) / FQ)), j1 = Math.min(F.rows - 1, Math.floor((u.y + s * K) / FQ));
    for (let j = j0; j <= j1; j++) {
      const dy = ((j + 0.5) * FQ - u.y) / K;
      for (let i = i0; i <= i1; i++) {
        const k = j * F.cols + i;
        if (S[k]) continue;
        const dx = (i + 0.5) * FQ - u.x;
        if (dx * dx + dy * dy < s * s) { S[k] = 1; F.ver[u.team]++; }
      }
    }
  }
}

// 列傳目錄：列傳 → 篇 → 章（選單照這個排）；ready: false 的列傳顯示「製作中」
const LISTS = [
  { id: 'sunwu', name: '孫吳傳', years: '184–222', parts: [
    { name: '孫堅篇', chapters: ['sunjian-1', 'sunwu-3', 'sunwu-4'] },
    { name: '孫策篇', chapters: ['sunwu-5', 'sunwu-6', 'sunwu-7', 'sunwu-8', 'sunwu-9'] },
    { name: '赤壁篇', chapters: ['sunwu-10', 'sunwu-11', 'sunwu-12', 'sunwu-14'] },
    { name: '孫權篇', chapters: ['sunwu-15', 'sunwu-16', 'sunwu-17', 'sunwu-18'] },
  ] },
  { id: 'caocao', name: '曹操傳', years: '190–219', parts: [
    { name: '起兵篇', chapters: ['caocao-1', 'caocao-2', 'caocao-3', 'caocao-4', 'caocao-5', 'caocao-6'] },
    { name: '霸業篇', chapters: ['caocao-7', 'caocao-8', 'caocao-9'] },
    { name: '赤壁以後', chapters: ['caocao-10', 'caocao-11', 'caocao-12'] },
  ] },
  { id: 'liubei', name: '劉備傳', years: '184–223', parts: [
    { name: '流離篇', chapters: ['liubei-1', 'liubei-2', 'liubei-3', 'liubei-4'] },
    { name: '荊州篇', chapters: ['liubei-5', 'liubei-6', 'liubei-7'] },
    { name: '益州篇', chapters: ['liubei-8', 'liubei-9', 'liubei-10', 'liubei-11'] },
  ] },
  ...SOLO.map((L) => L.list),
];
// 每章拿過的最多星數（先存在這台瀏覽器；之後接雲端存檔）
const STARS_KEY = 'sg-campaign-stars';
const loadStars = () => { try { return JSON.parse(localStorage.getItem(STARS_KEY) || '{}'); } catch (e) { return {}; } };

SG.CAMPAIGN = {
  maps: MAPS,
  chapters: CHAPTERS,
  lists: LISTS,
  cast: CAST, // 每章的主角與登場武將（列傳選單的武將小圖）
  people: PEOPLE, // 列傳另外做的人物（不在武將名單裡）
  // 這一章在哪一條列傳、哪一篇；同一章收在兩條列傳時（例如長坂坡在劉備傳和趙雲傳），先找玩家是從哪條列傳點進來的（via）
  via: null,
  partOf(id) {
    if (CHAPTERS[id] && CHAPTERS[id].of) id = CHAPTERS[id].of; // 分幕的後幾幕：算在第一幕那章
    for (const L of [...LISTS].sort((a, b) => (b.id === this.via) - (a.id === this.via))) for (const P of L.parts) if (P.chapters.includes(id)) return { list: L, part: P };
    return null;
  },
  // 章名，章號照所在的列傳重新編（同一章收在兩條列傳時，例如長坂坡在劉備傳是第 6 章、在趙雲傳是第 2 章）
  title(id, listId) {
    const d = CHAPTERS[id], first = d.of || id;
    const L = listId ? LISTS.find((x) => x.id === listId) : (this.partOf(first) || {}).list;
    const i = L ? L.parts.flatMap((P) => P.chapters).indexOf(first) : -1;
    return i < 0 ? d.title : d.title.replace(/^第 \d+ 章/, `第 ${i + 1} 章`);
  },
  // 分幕的章打完一幕：帶到下一幕的東西
  carry(w) {
    const me = w.player, m = w.campaign.mission;
    return { hero: me.spec.id, lv: me.lv, exp: me.exp, pts: me.pts, manual: me.manual, skillLv: me.skillLv.slice(), items: me.items.slice(), iq: me.iq && me.iq.slice(), gold: me.gold,
      prev: { vars: m.vars, stats: Object.assign({}, m.stats), lootN: m.lootN0 + m.loots.length } };
  },
  stars(id) { return loadStars()[id] || 0; },
  allStars() { return loadStars(); }, // { 章節 id: 星數 }（領黃金時整份送出）
  recordStars(id, n) {
    const S = loadStars();
    if (n <= (S[id] || 0)) return;
    S[id] = n;
    try { localStorage.setItem(STARS_KEY, JSON.stringify(S)); } catch (e) { /* 私密視窗：不記 */ }
  },
  active: null,
  // 開一個列傳世界：地圖 id、主角（武將資料）
  world(mapId, hero, opts = {}) {
    const def = MAPS[mapId];
    if (!def) throw new Error(`沒有這張列傳地圖：${mapId}`);
    SG.useMap(fieldMap(def));
    this.active = mapId;
    const w = new SG.World({ hero, lanes: ['road'], seed: opts.seed });
    w.campaign = { map: mapId, fog: makeFog(SG.MAP) };
    // 只留主角：其他武將與所有建築拿掉
    w.units = w.units.filter((u) => u === w.player);
    w.baseUnits = []; w.granary = [null, null]; w.camps = [];
    // 金錢只靠殺敵：沒有軍餉、起始 0 金
    w.tune = Object.assign({}, w.tune, { wage: 0, gold: 0 }); w.player.gold = 0;
    // 赤壁的地圖機制全部關掉
    w.waveT = Infinity; w.bossT = Infinity; w.cartT = Infinity; w.wind.next = Infinity; w.seal.t = Infinity;
    const b = SG.MAP.bases[0];
    w.player.sightK = def.sight || 1;
    w.player.team = 0; w.player.x = b.x + 160; w.player.y = b.y; w.player.f = 1;
    // 每一步之後更新探索紀錄（每 FOG_EVERY 秒一次）
    const step = w.step;
    const sightK = def.sight || 1;
    w.step = function (dt) {
      for (const u of this.units) if (u.sightK == null) u.sightK = sightK;
      step.call(this, dt);
      if (this.campaign.mission && this.over === null) this.campaign.mission.tick(dt);
      const F = this.campaign.fog;
      if ((F.t -= dt) <= 0) { F.t = FOG_EVERY; reveal(this); }
    };
    if (SG.Audio && SG.Audio.setTheme) SG.Audio.setTheme(def.music || null);
    return w;
  },
  // 開一章：章節的地圖、主角，加上任務
  chapter(id, opts = {}) {
    const ch = CHAPTERS[id];
    if (!ch) throw new Error(`沒有這一章：${id}`);
    const w = this.world(ch.map, opts.hero || ch.heroSpec || SG.HEROES.find((h) => h.id === ch.hero), opts); // heroSpec：主角不是可選武將（例如韓當）
    w.campaign.chapter = id;
    w.campaign.touch = !!opts.touch; // 觸控沒有 Shift＋右鍵：不教排路線
    const me = w.player, C = opts.carry;
    if (C && C.hero === me.spec.id) { // 分幕的章：同一個主角就把上一幕的等級、技能、裝備、金錢帶過來
      Object.assign(me, { lv: C.lv, exp: C.exp, pts: C.pts, manual: C.manual, skillLv: C.skillLv.slice(), items: C.items.slice(), iq: C.iq && C.iq.slice(), gold: C.gold });
      w.recalc(me); me.hp = me.maxHp; me.mp = me.maxMp;
    }
    const m = startMission(w, ch, C && C.prev);
    // 起始軍資（第 1 章、不打仗的章、分幕的後幾幕是 0）：每級 120 金；出發的地方設一個軍需處（「商」），出發前可以先買裝備
    const gold = C ? 0 : ch.gold != null ? ch.gold : 120 * me.lv;
    if (gold > 0) {
      me.gold += gold;
      SG.MAP.shops.push([me.x, me.y, 'village']);
      if (!SG.MAP.waterAt(me.x, me.y)) m.folk(me.x + 110, me.y - 70, { name: '軍需', still: true, near: 1, draw: SG.campaignDraw.supply });
      m.after(1, () => m.line('提示', `帶了 ${gold} 金軍資。出發前在起點的軍需處（地圖上的「商」）可以買裝備。`));
    }
    return w;
  },
  // 這一隊看過 (x, y) 沒有
  explored(w, team, x, y) {
    const F = w.campaign && w.campaign.fog;
    if (!F) return true;
    const i = Math.floor(x / F.q), j = Math.floor(y / F.q);
    return i >= 0 && j >= 0 && i < F.cols && j < F.rows && !!F.seen[team][j * F.cols + i];
  },
  leave() {
    if (!this.active) return;
    this.active = null;
    SG.useMap();
    if (SG.Audio && SG.Audio.setTheme) SG.Audio.setTheme(null);
  },
};
